<svg viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" stroke="#1C274C" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000" class="w-full h-full">
    <polyline points="4 13 9 18 20 7"></polyline>
</svg>